import { Box, Button, ClickAwayListener, IconButton, Menu, MenuItem, MenuList, Popover, Popper, Tooltip, Typography, useTheme } from '@mui/material'
import { ArrowDropDown, Videocam } from '@mui/icons-material'
import React, { useRef, useState } from 'react'

import { useMeetingStore } from '../../store/meeting.store'
import { Icons } from '../../utils/utilities'
import { toast } from 'react-toastify'

const MinimizedAudioSettingsBar = ( { open, setOpen, anchorEl, placement = "bottom-start", openSettings } ) => {

    const [micsAnchorEl, setMicsAnchorEl] = useState( null )
    const [speakersAnchorEl, setSpeakersAnchorEl] = useState( null )

    const { palette, border } = useTheme()

    const MeetingStore = useMeetingStore()

    const samAudioElement = useRef()
    const settingsBarRef = useRef()

    const handleClose = () => {
        setMicsAnchorEl( null )
        setSpeakersAnchorEl( null )
        setOpen( false )
    }


    const handleMicChange = async value => {
        try {
            MeetingStore.setMeetingState( { micId: value } )
            if ( MeetingStore.getMeetingState.isAudioOn ) {
                const audioTrack = MeetingStore.getLocalAudioTrack
                if ( audioTrack ) {
                    await audioTrack.setDevice( value )
                }
            }
            setMicsAnchorEl( null )
        } catch ( err ) {
            toast( "Failed to change audio device" )
            console.log( err )
        }
    }

    const handleSpeakerChange = async value => {
        MeetingStore.setMeetingState( { speakerId: value } )

        const audioElem = samAudioElement.current

        if ( audioElem && typeof audioElem.setSinkId !== "undefined" ) {
            try {
                await audioElem.setSinkId( value )
                // setSelectedOutputId( value ) // Save in state for later reference
            } catch ( err ) {
                console.error( "Error setting output device:", err )
            }
        } else {
            console.warn( "setSinkId not supported in this browser" )
        }
        setSpeakersAnchorEl( null )
    }

    const openSpeakers = ( event ) => {
        setMicsAnchorEl( null )
        setSpeakersAnchorEl( event.currentTarget )
    }

    const openMics = ( event ) => {
        setMicsAnchorEl( event.currentTarget )
        setSpeakersAnchorEl( null )
    }


    return (
        <Popper container={anchorEl.current} sx={{ zIndex: 3000 }} open={open} placement='top-start' anchorEl={anchorEl.current} >

            <ClickAwayListener onClickAway={handleClose} >
                <Box ref={settingsBarRef} display="flex" flexDirection={{ md: "row", xs: "column" }} gap="10px" padding={{ xs: "10px", md: "5px 10px" }} marginBottom="5px" borderRadius="20px" bgcolor={palette.rowHover}>
                    <Button sx={{ borderRadius: "20px", justifyContent: "flex-start" }} disabled={!MeetingStore.getMeetingState?.micId} onClick={openMics} endIcon={<ArrowDropDown fontSize='small' />} startIcon={Icons.default.Mic} color="greyed" variant='outlined'>
                        <Typography color={!MeetingStore.getMeetingState?.micId ? "GrayText" : palette.common.font} flexGrow={1} textAlign="left" variant='subtitle2' noWrap  >{!MeetingStore.getMeetingState?.micId ? "Permission required..." : MeetingStore.getIoDevices?.mics?.find( mic => mic.deviceId === MeetingStore.getMeetingState?.micId )?.label}</Typography>
                    </Button>
                    <Button sx={{ borderRadius: "20px", justifyContent: "flex-start" }} disabled={!MeetingStore.getMeetingState?.micId} onClick={openSpeakers} endIcon={<ArrowDropDown fontSize='small' />} startIcon={Icons.default.VolumeUpIcon} color="greyed" variant='outlined'>
                        <Typography color={!MeetingStore.getMeetingState?.micId ? "GrayText" : palette.common.font} flexGrow={1} textAlign="left" variant='subtitle2' noWrap  >{!MeetingStore.getMeetingState?.micId ? "Permission required..." : MeetingStore.getIoDevices?.speakers?.find( speaker => speaker.deviceId === MeetingStore.getMeetingState?.speakerId )?.label}</Typography>
                    </Button>
                    <Button sx={{ borderRadius: "20px", justifyContent: "flex-start", paddingX: "15px", display: { md: "none", xs: "flex" }, "& .MuiButton-icon": { marginLeft: "0" } }} disabled={!MeetingStore.getMeetingState?.speakerId} onClick={openSettings} startIcon={Icons.default.Settings} color="greyed" variant='text'>
                        Open Audio settings
                    </Button>
                    <Box display={{ md: "block", xs: "none" }}>
                        <Tooltip disableFocusListener disableInteractive placement='top' title="Audio Settings">
                            <IconButton onClick={openSettings} >
                                {Icons.default.Settings}
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Popper sx={{ zIndex: 3200 }} anchorEl={settingsBarRef.current} placement='top-start' open={Boolean( micsAnchorEl )}  >
                        <Box marginBottom="5px" padding="1px" overflow='clip' borderRadius="10px" bgcolor={palette.rowHover}>
                            <MenuList>
                                {MeetingStore.getIoDevices.mics.map( mic => (
                                    <MenuItem onClick={() => handleMicChange( mic.deviceId )} dense selected={mic.deviceId === MeetingStore.getMeetingState?.micId} sx={{ fontSize: "14px" }} value={mic.deviceId} key={mic.deviceId}>{mic.label}</MenuItem>
                                ) )}
                            </MenuList>
                        </Box>
                    </Popper>
                    <Popper sx={{ zIndex: 3200 }} anchorEl={settingsBarRef.current} placement='top-end' open={Boolean( speakersAnchorEl )}  >
                        <Box marginBottom="5px" padding="1px" overflow='clip' borderRadius="10px" bgcolor={palette.rowHover}>
                            <MenuList>
                                {MeetingStore.getIoDevices.speakers.map( speaker => (
                                    <MenuItem onClick={() => handleSpeakerChange( speaker.deviceId )} dense selected={speaker.deviceId === MeetingStore.getMeetingState?.speakerId} sx={{ fontSize: "14px" }} value={speaker.deviceId} key={speaker.deviceId}>{speaker.label}</MenuItem>
                                ) )}
                            </MenuList>
                        </Box>
                    </Popper>
                </Box>

            </ClickAwayListener >
        </Popper>
    )
}

export default MinimizedAudioSettingsBar
